// extracted by mini-css-extract-plugin
export var address = "Footer-module--address--2ba17";
export var container = "Footer-module--container--a064f";
export var follow = "Footer-module--follow--13080";
export var img = "Footer-module--img--52906";
export var links = "Footer-module--links--cdb68";
export var logoImg = "Footer-module--logoImg--0fb6e";
export var media = "Footer-module--media--29063";
export var name = "Footer-module--name--8c710";
export var text = "Footer-module--text--13ef1";
export var titleAddress = "Footer-module--titleAddress--cec30";